import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const edsExceptionScorecardAssignmentSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        createScorecardAssign: builder.mutation({
            query: (arg: any) => ({
                url: constants.SCORECARD_ASSIGN_CREATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['ScExAssignment'],
        }),
        getScoreCardOverrideTypes: builder.query({
            query: (arg: any) => {
                console.log(arg);
                return {
                    url: constants.DISPUTE_GET_SCORECARD_OVERRIDE,
                };
            },
        }),
        getScoreCards: builder.query({
            query: (arg: any) => {
                console.log(arg);
                return {
                    url: constants.DISPUTE_GET_SCORECARDS,
                };
            },
        }),
     
        getScoreCardAssignOverrides: builder.query({
            query: (arg: any) => {
                const { employeenumber, scorecardId } = arg;
                return {
                    url: constants.SCORECARD_ASSIGN_OVERRIDE_EXCEPTIONS,
                    params: { employeenumber, scorecardId },
                };
            },
            providesTags: ['ScExAssignment'],
        }),
        deleteScoreCardAssignOverrides: builder.mutation({
            query: (arg: any) => ({

                url: constants.DELETE_SCORECARD_ASSIGN_OVERRIDE_EXCEPTIONS,
                method: 'PUT',
                body: arg.scorecardId,
                params: {oracleIDs : arg.oracleIDs},
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),

            invalidatesTags: ['ScExAssignment'],
        }),
    }),
});
export const{
    useCreateScorecardAssignMutation,
    useGetScoreCardOverrideTypesQuery,
    useGetScoreCardsQuery,
    useGetScoreCardAssignOverridesQuery,
    useDeleteScoreCardAssignOverridesMutation
}=edsExceptionScorecardAssignmentSlice